import { render } from "./ApresentarMiniaturaCampoPersonalizado.vue?vue&type=template&id=ed1e9ca2&scoped=true&ts=true"
import script from "./ApresentarMiniaturaCampoPersonalizado.vue?vue&type=script&lang=ts"
export * from "./ApresentarMiniaturaCampoPersonalizado.vue?vue&type=script&lang=ts"

import "./ApresentarMiniaturaCampoPersonalizado.vue?vue&type=style&index=0&id=ed1e9ca2&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed1e9ca2"]])

export default __exports__